module.exports = __webpack_public_path__ + "static/media/leaf-empty.9ae67591.svg";